var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.95,
    height: 10.063,
    viewBox: "0 0 4.95 10.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".selectIcon{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.592 -3.964)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.592 3.964)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "selectIcon",
    d: "M22.542,9.321v1.645a5.153,5.153,0,0,1-.119,1.1l-.107.488H18.988L18.2,11.406a.957.957,0,0,1-.168-.545V9.834a.957.957,0,0,1,.224-.618L18.437,9v1.064a.258.258,0,1,0,.515,0V5.785a.319.319,0,1,1,.638,0c0,.008,0,.016,0,.023l.18,2.175c0,.006,0,.011,0,.016a.277.277,0,0,0,0,.028c0,.009,0,.017.008.025s.006.016.009.024l.013.024.013.021.015.019.019.02.016.014.024.017.017.01.028.013.02.006.019.006,2.09.4a.729.729,0,0,1,.471.692ZM22.354,13.1H18.845a.176.176,0,0,0-.172.179v.573a.176.176,0,0,0,.172.179H22.37a.176.176,0,0,0,.172-.179s-.01-.357-.016-.579A.175.175,0,0,0,22.354,13.1ZM18.373,6.956a.278.278,0,0,0,.026-.38,1.3,1.3,0,0,1,.074-1.722,1.163,1.163,0,0,1,1.65-.017,1.3,1.3,0,0,1,.107,1.721.278.278,0,0,0,.033.379.25.25,0,0,0,.363-.035,1.85,1.85,0,0,0-.153-2.459,1.663,1.663,0,0,0-2.359.024,1.851,1.851,0,0,0-.106,2.462A.25.25,0,0,0,18.373,6.956Z",
    transform: "translate(-17.592 -3.964)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/Select.e17d1bdb.svg";
export { ForwardRef as ReactComponent };